import type { $Fetch } from 'ofetch';
import type { EbookGateway } from '@/application/port/out/EbookGateway';
import type { CreateEbookCommand, Ebook, ListEbooksParams, UpdateEbookCommand } from '@/domain/model/Ebook';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** Gateway HTTP de Ebook — BE `/api/v1/ebooks` (multipart no create, blob no download). */
export class HttpEbookGateway implements EbookGateway {
  private readonly path = '/api/v1/ebooks';
  constructor(private readonly client: $Fetch) {}

  async list(p: ListEbooksParams): Promise<Ebook[]> {
    const params: Record<string, string> = {};
    if (p.disciplineId) params['disciplineId'] = p.disciplineId;
    const res = await this.client<ApiResponse<Ebook[]>>(this.path, { method: 'GET', params });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: CreateEbookCommand): Promise<Ebook> {
    const formData = new FormData();
    formData.append('titulo', cmd.titulo);
    if (cmd.disciplineId) formData.append('disciplineId', cmd.disciplineId);
    if (cmd.areaId) formData.append('areaId', cmd.areaId);
    if (cmd.educationLevelId) formData.append('educationLevelId', cmd.educationLevelId);
    formData.append('ativo', String(cmd.ativo));
    formData.append('arquivo', cmd.arquivo);
    const res = await this.client<ApiResponse<Ebook>>(this.path, { method: 'POST', body: formData });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpdateEbookCommand): Promise<Ebook> {
    const res = await this.client<ApiResponse<Ebook>>(`${this.path}/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: cmd,
    });
    assertApiSuccess(res);
    return res.data;
  }

  async arquivar(id: string): Promise<void> {
    await this.client<void>(`${this.path}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }

  async baixar(id: string): Promise<Blob> {
    return await this.client(`${this.path}/${encodeURIComponent(id)}/download`, { responseType: 'blob' });
  }
}
